import { CATEGORIES_TYPES, PRODUCT_TYPE_STRUCTURE_TYPES, IOrderLine } from '@cakeiteasy/web-utils';
import { ICakeCartLine } from '../../cart/models/cart/i-cake-cart-line';
import { getCakeCartLineTotalPrice } from '../../cart/helpers/cart-helper';
import { CART_LINE_TYPES } from '../../cart/constants/common';

export const getCartLineTrackingNameFn = (ignoreProductData = false) => (line: ICakeCartLine): string => {
  if (ignoreProductData || !line.product) {
    return line.name;
  }

  if (line.product.type.structureType === PRODUCT_TYPE_STRUCTURE_TYPES.PIECES_GROUP) {
    return line.product.variant.name;
  }

  return line.product.type.name;
};

export const getProductTrackingName = ({ product, name }: ICakeCartLine): string => {
  if (!product) {
    return name;
  }

  const { PIECES_GROUP } = PRODUCT_TYPE_STRUCTURE_TYPES;
  const isPiecesGroup = product.type.structureType === PIECES_GROUP;

  if (isPiecesGroup) {
    return product.variant.name;
  }

  return name;
};

export const capitalizeString = (str: string) => {
  const strFormatted = str.split('_').join(' ').toLowerCase();
  return strFormatted.charAt(0).toUpperCase() + strFormatted.slice(1);
};

export const getTotalPriceValue = (cartLines: ICakeCartLine[], discount?: number): number => {
  return cartLines.reduce((acc, line) => (acc += getCakeCartLineTotalPrice({ line, discount }), acc), 0);
};

export const getDiscountOrderLine = (orderLines: IOrderLine[]) => {
  return orderLines.find(line => line.type === CART_LINE_TYPES.DISCOUNT);
};

export const formatPrice = (price: number) => price.toFixed(2);

export const floatFormatPrice = (price: number) => parseFloat(price.toFixed(2));
